import React, { useState, useMemo, useEffect } from 'react'
import axios from 'axios';

// import { useNavigate } from 'react-router-dom';
import { MachineConfigurationColumns } from '../components/machine_configuration_columns'
import MainLayout from '../layout/MainLayout';
import BasicTable from '../components/BasicTable'
import KnittingmachineConfigurationNew from '../new_pages/KnittingmachineConfigurationNew';
import useDeleteWithConfirmation from '../components/useDeleteWithConfirmation';
import DeleteConfirmation from '../components/DeleteConfirmation';
import { formatTimestampNow } from '../utils/functions';
import { convertCommaToDotForFloatFields, setDefaultForEmptyNumberFields, handleFocus, handleBlur, validateField } from '../utils/functions';
import IncorrectInputModalModal from '../components/IncorrectInputModal'; // Importiere die Modal-Komponente zur Ausgabe bei Fehleingaben vom User
import { url_root } from '../config'; // Importiere die Konfigurationsdaten

import '../components/ChangeInputArea.css'
import '../components/PopupDatasheet.css'


function KnittingmachineConfigurationPage() {
  
  // const navigate = useNavigate();
  const access_token = window.localStorage.getItem('access_token');

  const [machineConfiguration, setMachineConfiguration] = useState([]);
  const [machinetypeNameOptions, setMachinetypeNameOptions] = useState([]); // Zustand für Machinentyp-Namen
  
  const [threadTensionhUnitOptions, setThreadTensionUnitOptions] = useState([]); // Zustand für die Maßeinheiten der Fadenspannung
  const [speedUnitOptions, setSpeedUnitOptions] = useState([]); // Zustand für die Geschwindigkeitsmaße
  const [culletDepthUnitOptions, setCulletDepthUnitOptions] = useState([]); // Zustand für die Kuliertiefenmaße
  const [hauloffAdjustmentUnitOptions, setHauloffAdjustmentUnitOptions] = useState([]); // Zustand für die Maße Abzugseinstellung
  const [sinkerAdjustmentUnitOptions, setSinkerAdjustmentUnitOptions] = useState([]); // Zustand für die Maße Sinkereinstellung

  const [isNewPopupOpen, setIsNewPopupOpen] = useState(false); // für Popup Neuer Datensatz

  const [imageUrl, setImageUrl] = useState(null);
  const [copiedData, setCopiedData] = useState(null); // Zustand für kopierte Daten
  const [clickedAnyIcon, setClickedAnyIcon] = useState(false); // Zustandsvariable, um zu überprüfen, welches Symbol geklickt wurde

  const [newSelectedRowID, setNewSelectedRowID] = useState(null);

  const [errors, setErrors] = useState({}); // Zustand für Fehler pro Feld
  const [errorMessage, setErrorMessage] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false); // Zustand für die Anzeige des Modals
  
  const id_institution = window.localStorage.getItem('id_institution');
  const id_role = window.localStorage.getItem('id_role');
  // const warningThreshold = window.localStorage.getItem("warning_threshold");

  const can_create_machine_configuration = JSON.parse(window.localStorage.getItem('can_create_machine_configuration'));
  const can_update_machine_configuration = JSON.parse(window.localStorage.getItem('can_update_machine_configuration'));
  const can_delete_machine_configuration = JSON.parse(window.localStorage.getItem('can_delete_machine_configuration'));


  /* post-State Objekt, um Daten zu speichern, die vom Nutzer eingegeben werden */
  const [post, setPost] = useState({
    // machine_configuration:
    id_machine_configuration: '',
    machine_configuration_name: '',
    machinetype_name: '',
    product: '',
    yarn_feeder: '',
    additional_special_feeder: '',
    thread_tension: '',
    unit_thread_tension_name: '',
    carriage_speed: '',
    unit_carriage_speed_name: '',
    cullet_depth: '',
    unit_cullet_depth_name: '',
    hauloff_adjustment: '',
    unit_hauloff_adjustment_name: '',
    inserter_for_weft_thread: false,
    builtin_rail_warp_threads: false,
    sinker_adjustment: '',
    unit_sinker_adjustment_name: '',
    machine_configuration_others: '',
    machine_configuration_all_can_read: false, 
    timestamp: '',
  });


  // Funktion zum Leeren der Eingabefelder
  const clearFields = () => {
    setPost({
      // machine_configuration:
      id_machine_configuration: '',
      machine_configuration_name: '',
      machinetype_name: '',
      product: '',
      yarn_feeder: '',
      additional_special_feeder: '',
      thread_tension: '',
      unit_thread_tension_name: '',
      carriage_speed: '',
      unit_carriage_speed_name: '',
      cullet_depth: '',
      unit_cullet_depth_name: '',
      hauloff_adjustment: '',
      unit_hauloff_adjustment_name: '',
      inserter_for_weft_thread: false,
      builtin_rail_warp_threads: false,
      sinker_adjustment: '',
      unit_sinker_adjustment_name: '',
      machine_configuration_others: '',
      machine_configuration_all_can_read: false, 
      timestamp: '',
    });
    setErrors({});
  };


  // wird beim Rendern der Komponente ausgeführt
  useEffect(() => {
    fetchMachineConfiguration();
    fetchMachinetypeOptions();
    fetchUnitOptions('thread_tension_unit', setThreadTensionUnitOptions);
    fetchUnitOptions('speed_unit', setSpeedUnitOptions);
    fetchUnitOptions('cullet_depth_unit', setCulletDepthUnitOptions);
    fetchUnitOptions('hauloff_adjustment_unit', setHauloffAdjustmentUnitOptions);
    fetchUnitOptions('sinker_adjustment_unit', setSinkerAdjustmentUnitOptions);
  }, []);


  /*useEffect(() => {
    const checkTokenExpiry = () => {
      console.log("Initializing token expiry check...");

      const expiresAt = window.localStorage.getItem("expires_at");
      if (!expiresAt) return;

      const expiryDate = new Date(expiresAt);
      const now = new Date();
      const timeLeft = expiryDate - now;

      if (timeLeft <= 0) {
        logoutUser();
      } else if (timeLeft <= parseInt(warningThreshold, 10)) { // Warnschwelle von 1 Minuten
        // Zeige Warnung
        showExpiryWarning();
      }        
    };

    const logoutUser = () => {
      console.log("Logging out user due to token expiry.");
      window.localStorage.clear(); // Bereinige gespeicherte Daten
      navigate('/'); // Weiterleitung zur Login-Seite
      
    };
  
    const showExpiryWarning = () => {
      console.log("Warning out user due to token expiry.");
      if (!window.localStorage.getItem("warned_about_expiry")) {
        alert("Ihre Sitzung läuft bald ab. Bitte speichern Sie Ihre Arbeit.");
        window.localStorage.setItem("warned_about_expiry", true); // Verhindert wiederholte Warnungen
      }
    };
   

    // Überwachung alle 5 Sekunden
    const intervalId = setInterval(checkTokenExpiry, 5 * 1000); //5 Sekunden
  
    return () => clearInterval(intervalId); // Cleanup bei unmount
  }, [navigate]); */
  


  // Anzeige der Eingabefelder unter der Tabelle zum Aendern
  const fields = [
    { name: 'machinetype_name', label: 'Bezeichnung Maschinentyp', type: 'text' },
    { name: 'machine_configuration_name', label: 'Bezeichnung Maschinenkonfiguration', type: 'text', validate: { required: true} },
    { name: 'product', label: 'Produkt', type: 'text' },
    { name: 'yarn_feeder', label: 'Fournisseur', type: 'textarea' },
    { name: 'additional_special_feeder', label: 'Spezielle Fournisseur', type: 'textarea' },
    { name: 'thread_tension', label: 'Fadenspannung', type: 'textarea', unit: 'unit_thread_tension_name' },
    { name: 'carriage_speed', label: 'Schlittengeschwindigkeit', type: 'text', unit: 'unit_carriage_speed_name', validate: { float: true} },
    { name: 'cullet_depth', label: 'Kuliertiefe', type: 'text', unit: 'unit_cullet_depth_name', validate: { integer: true} },
    { name: 'hauloff_adjustment', label: 'Abzugseinstellung', type: 'text', unit: 'unit_hauloff_adjustment_name', validate: { float: true} },
    { name: 'inserter_for_weft_thread', label: 'Einstreifer für Schussfaden', type: 'checkbox' },
    { name: 'builtin_rail_warp_threads', label: 'Schiene für Zuführung von Kettfäden', type: 'checkbox' },
    { name: 'sinker_adjustment', label: 'Sinker', type: 'text', unit: 'unit_sinker_adjustment_name', validate: { integer: true} },
    { name: 'machine_configuration_others', label: 'Sonstige', type: 'textarea' },
    { name: 'machine_configuration_all_can_read', label: 'Freigabe für alle Institutionen (Lesen)', type: 'checkbox' }, 
  ];


  // Funktion, um Benutzereingaben in Formularfeldern zu verarbeiten
  const handleInput = (event) => {
    const { name, value, type, checked } = event.target;
    setPost({ ...post, [name]: type === 'checkbox' ? checked : value });
  }


  // Funktion zum Einfuegen der Tabellen-Daten
  const fetchMachineConfiguration = async () => {
    try {
      const id_machinetype = window.localStorage.getItem('id_machinetype');
      const param = {
        headers: {
          'Authorization': `Bearer ${access_token}`,
          'idInstitution': id_institution,
          'idRole': id_role, 
          'idMachinetype': id_machinetype              
        }
      };
      const response = await axios.get(
        `${url_root}/get_all_knit_machine_configuration_to_role_machinetype_ext`, param
      );
      
      setMachineConfiguration(response.data);
      return response.data.knit_machine_configuration_ext || [];
    } catch (error) {
      console.error('Error fetching data:', error);
      return [];
    }
  }; 


  // Funktion zum Abrufen aller Maschinentyp-Namen
  const fetchMachinetypeOptions = async () => {
    try {
      const param = {
        headers: {
          'Authorization': `Bearer ${access_token}`,
          'idRole': id_role,
          'idInstitution': id_institution   
        }
      };
      const response = await axios.get(`${url_root}/get_all_knit_machinetype_to_institution`, param);
      setMachinetypeNameOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der machinetypeOptions:', error);
    }
  };


  // Funktion zum Abrufen und Ermitteln der Masseinheiten nach unit_type
  const fetchUnitOptions = async (unitType, setUnitOptions) => {
    try {
      const param = {
        headers: {
          'Authorization': `Bearer ${access_token}`,
          'unitType': unitType          
        }
      };     
      const response = await axios.get(`${url_root}/get_all_knit_unit_to_type`, param);      
      setUnitOptions(response.data);
    } catch (error) {
      console.error(`Fehler beim Abrufen der ${unitType}UnitOptions:`, error);
    }
  };


  // Funktion zum Abrufen des Bildes vom Machinetype
  const fetchImageFromMachinetypeId = async (idMachinetype) => {
    try {
      const param = {
        headers: {
          'Authorization': `Bearer ${access_token}`,
          'idMachinetype': idMachinetype          
        }
      };     
      const response = await axios.get(`${url_root}/get_knit_image_to_machinetype_id`, param);
      return response.data.filename

    } catch (error) {
      console.error('Fehler beim Abrufen der machinetypeOptions:', error);
    }
  };


  // Funktion zum Abrufen und Ermitteln der Institutionen
  const fetchInstitutionNameFromMachinetypeId = async (idMachinetype) => {
    try {
      const param = {
        headers: {
          'Authorization': `Bearer ${access_token}`,
          'idMachinetype': idMachinetype
        }
      };     
      const response = await axios.get(`${url_root}/get_knit_institution_name_to_idmachinetype `, param);  
      return response.data.institution_name          
    } catch (error) {
      console.error(`Fehler beim Abrufen des institution_name to idMachinetype:`, error);
    }
  };


  // Funktion zum Anzeigen des Bildes bei Klick auf eine Zeile in der Tabelle, wird von der BasicTable aufgerufen
  // und bei Aenderungen eines Datensatzes
  const showImage = async (imageName, idMachinetype, institutionName) => {
    try {
      // Ermitteln des Bildnamens aus Tabelle Machinetyp
      const imageFromMachinetype = await fetchImageFromMachinetypeId(idMachinetype);

      // Ermittlen des institutionId aus machinetype
      const institutionNameFromMachinetype = await fetchInstitutionNameFromMachinetypeId(idMachinetype);

      const param = {
        headers: {
          'imageName': imageFromMachinetype,
          'institutionName': institutionNameFromMachinetype,
          'pageType' : 'machinetype',
          'Authorization': `Bearer ${access_token}`      
        },
        responseType: 'blob' // Setzt den Antworttyp auf Blob
      };     
      const response = await axios.get(`${url_root}/show_image_from_server`, param);
      const imageBlob = response.data;

      const imageObjectURL = URL.createObjectURL(imageBlob); // Blob in eine URL konvertieren

      setImageUrl(imageObjectURL); // URL in den State setzen
    }catch (error) {
      console.error('Bild zu Maschinentyp konnte nicht abgerufen werden.');
    }
  };
  

  // Vermeidung von Zugriff auf Eigenschaften von null oder leeres Array
  const knitMachineConfigurationExtArray = machineConfiguration && machineConfiguration.knit_machine_configuration_ext; 

  // Verwende das knitYarnExtArray als Daten für die Tabelle
  const data = useMemo(() => knitMachineConfigurationExtArray || [], [knitMachineConfigurationExtArray]);

  // Definiere den Accessor für die BasicTable
  const accessor = 'id_machine_configuration';


  // Funktion zur Uebertragung des Datensatzes in die Eingabefelder zum Aendern
  const handleButtonChange = (id) => {
    if (!id) {
      return;
    }

    setErrors({});

    // Datensatz der übergebenen id_machinetype ermitteln
    const changeMachineConfigurationData = data.find(row => row.id_machine_configuration === id);

    // Wenn kein Datensatz gefunden wird, abbrechen
    if (!changeMachineConfigurationData) {
      return;
    }

    // Aktuellen Zeitstempel abrufen und formatieren
    const timestamp = formatTimestampNow();

    setPost({
      id_machine_configuration: changeMachineConfigurationData.id_machine_configuration,
      machine_configuration_name: changeMachineConfigurationData.machine_configuration_name || '',
      machinetype_name: changeMachineConfigurationData.machinetype_name || '',
      product: changeMachineConfigurationData.product || '',
      yarn_feeder: changeMachineConfigurationData.yarn_feeder || '',
      additional_special_feeder: changeMachineConfigurationData.additional_special_feeder || '',
      thread_tension: changeMachineConfigurationData.thread_tension || '',
      unit_thread_tension_name: changeMachineConfigurationData.unit_thread_tension_name || '',
      carriage_speed: changeMachineConfigurationData.carriage_speed,
      unit_carriage_speed_name: changeMachineConfigurationData.unit_carriage_speed_name || '',
      cullet_depth: changeMachineConfigurationData.cullet_depth,
      unit_cullet_depth_name: changeMachineConfigurationData.unit_cullet_depth_name || '',
      hauloff_adjustment: changeMachineConfigurationData.hauloff_adjustment,
      unit_hauloff_adjustment_name: changeMachineConfigurationData.unit_hauloff_adjustment_name || '',
      inserter_for_weft_thread: changeMachineConfigurationData.inserter_for_weft_thread || false,
      builtin_rail_warp_threads: changeMachineConfigurationData.builtin_rail_warp_threads || false,
      sinker_adjustment: changeMachineConfigurationData.sinker_adjustment,
      unit_sinker_adjustment_name: changeMachineConfigurationData.unit_sinker_adjustment_name || '',
      machine_configuration_others: changeMachineConfigurationData.machine_configuration_others || '',
      machine_configuration_all_can_read: changeMachineConfigurationData.machine_configuration_all_can_read || false,     
      //timestamp: timestamp, // aktueller timestamp
      timestamp: changeMachineConfigurationData.timestamp || formatTimestampNow(),
    })
  };


  // Funktion zum Speichern des geaenderten Datensatzes
  const handleSave = async (id) => {
    try {
      if (id === "" || id === undefined) {
        setErrorMessage("Bitte wählen Sie eine Maschinenkonfiguration zum Ändern aus oder legen Sie mit NEU eine neue Maschinenkonfiguration an.");
        setShowErrorModal(true);
        return;
      }
      
      // Ueberpruefung, ob es noch Fehleingaben gibt
      const hasErrors = Object.values(errors).some(error => error !== '');

      if (hasErrors) {
        // Zeige das Modal-Popup, wenn noch Fehler vorhanden sind
        setErrorMessage("Bitte korrigieren Sie die fehlerhaften Felder, bevor Sie speichern.");
        setShowErrorModal(true);
        return; // Stoppe das Speichern, bis die Fehler behoben sind
      }

      // Fehler zuruecksetzen, falls alles korrekt ist
      setErrors({});

      // Erstellen einer Kopie des Datensatzes, um ihn zu bearbeiten
      const modifiedPost = { ...post };

      // Setze leere Float- und Integer-Felder auf -123
      setDefaultForEmptyNumberFields(modifiedPost, fields);
      // Konvertiere Komma in Punkt nur bei Feldern mit { float: true }
      convertCommaToDotForFloatFields(modifiedPost, fields);

      const response = await axios.put(`${url_root}/modify_knit_machine_configuration_to_id`, modifiedPost,
          {
            headers: {
                'Authorization': `Bearer ${access_token}`
            }
          }
      );

      newSaveID(id); // Zeile des geänderten Datensatzes bleibt in der BasicTable markiert
      
      // Auffrischen der id_machinetype, da sonst undefined und die Tabelle dadurch leer angezeigt wird (nach Aufruf fetchMachineConfiguration)
      const refreshIdMachinetype = response.data.id_machinetype;
      window.localStorage.setItem('id_machinetype', refreshIdMachinetype);

      fetchMachineConfiguration(); // Tabelle aktualisieren
      setClickedAnyIcon(false); // Setzt den Zustand des geklickten Symbols auf false, d.h. icon wird wieder blau
      clearFields();
    } catch (error) {
      console.error('Error saving data:', error);
    }
  };


  // Funktion zum Kopieren des Datensatzes
  const handleButtonCopy = (id) => {    
    const copyMachineConfigurationData = data.find(row => row.id_machine_configuration === id);

    const adjustedData = { ...copyMachineConfigurationData }; // Eine Kopie der Daten erstellen, um sie zu bearbeiten

    // Für alle Felder im Objekt prüfen, ob der Wert 0, -123 oder null ist (Wert null ist in DB, wenn id=0)
    Object.keys(adjustedData).forEach(field => {
        if (adjustedData[field] === 0 || adjustedData[field] === -123 || adjustedData[field] === null) {
            adjustedData[field] = ''; // Wert in leeren String umwandeln
        }
    });

    clearFields(); // Ändern-Felder leeren, da der Fokus zum Kopieren der Daten neu gesetzt wird, das wäre verwirrend
    setCopiedData(adjustedData); // Angepasste Daten im Zustand speichern
  };


  // Abfrage zum Loeschen Datensatz als popup in extra Komponente und useHook ausgelagert:
  const deleteApiUrl = `${url_root}/delete_knit_machine_configuration_to_id`;
  // benutzerdefinierter Hook useDeleteWithConfirmation kapselt die Loeschlogik und den Zustand des Bestaetigungs-Popups
  const {
    isDeletePopupOpen,
    handleButtonDelete,
    handleConfirmDelete,
    closeDeletePopup,
  } = useDeleteWithConfirmation(deleteApiUrl, fetchMachineConfiguration, clearFields);

  
  // Funktion zum Oeffnen des Popups für das Hinzufuegen eines neuen Datensatzes
  const openNewEntryPopup = () => {
    setClickedAnyIcon(true); // Setzt den Zustand des geklickten Symbols auf false, wenn das newPopup geschlossen wird
    setIsNewPopupOpen(true);
  };


  // Funktion zum Schliessen des Popups für neue Eintraege
  const closeNewPopup = () => {
    setCopiedData(null); // Setze copiedData auf null, Eingabefelder werden geleert
    setClickedAnyIcon(false); // Setzt den Zustand des geklickten Symbols auf false, wenn das newPopup geschlossen wird
    setIsNewPopupOpen(false);
    clearFields();
  };


  // Funktion zum Markieren des neuen Datensatzes in BasicTable
  const newSaveID = (id) => {
    setNewSelectedRowID(id) // newSelectedRowID wird auf den Wert der machine_configuration_id gesetzt
  };


  // Daten aus anderer Tabelle
  const filteredDataMachinetypeName = machinetypeNameOptions && machinetypeNameOptions.knit_machinetype ? machinetypeNameOptions.knit_machinetype.filter(item => item.id_machinetype !== 0) : [];
  const sortedMachinetypeNameOptions = Array.from(new Set(filteredDataMachinetypeName.map(item => item.name))).sort();

  // Daten aus knit_unit
  const filteredDataThreadTensionUnit = threadTensionhUnitOptions && threadTensionhUnitOptions.knit_unit_to_unit_type ? threadTensionhUnitOptions.knit_unit_to_unit_type.filter(item => item.id_unit !== 0) : [];
  const sortedThreadTensionUnitOptions = Array.from(new Set(filteredDataThreadTensionUnit.map(item => item.name))).sort();

  const filteredDataSpeedUnit = speedUnitOptions && speedUnitOptions.knit_unit_to_unit_type ? speedUnitOptions.knit_unit_to_unit_type.filter(item => item.id_unit !== 0) : [];
  const sortedSpeedUnitOptions = Array.from(new Set(filteredDataSpeedUnit.map(item => item.name))).sort();

  const filteredDataCulletDepthUnit = culletDepthUnitOptions && culletDepthUnitOptions.knit_unit_to_unit_type ? culletDepthUnitOptions.knit_unit_to_unit_type.filter(item => item.id_unit !== 0) : [];
  const sortedCulletDepthUnitOptions = Array.from(new Set(filteredDataCulletDepthUnit.map(item => item.name))).sort();

  const filteredDataHauloffAdjustmentUnit = hauloffAdjustmentUnitOptions && hauloffAdjustmentUnitOptions.knit_unit_to_unit_type ? hauloffAdjustmentUnitOptions.knit_unit_to_unit_type.filter(item => item.id_unit !== 0) : [];
  const sortedHauloffAdjustmentOptions = Array.from(new Set(filteredDataHauloffAdjustmentUnit.map(item => item.name))).sort();

  const filteredDataSinkerAdjustmentUnit = sinkerAdjustmentUnitOptions && sinkerAdjustmentUnitOptions.knit_unit_to_unit_type ? sinkerAdjustmentUnitOptions.knit_unit_to_unit_type.filter(item => item.id_unit !== 0) : [];
  const sortedSinkerAdjustmentUnitOptions = Array.from(new Set(filteredDataSinkerAdjustmentUnit.map(item => item.name))).sort();

  
  return (
    <MainLayout openNewEntryPopup={openNewEntryPopup} >
      <BasicTable 
        columns={MachineConfigurationColumns} 
        accessor={accessor}
        data={data} 
        handleButtonChange={handleButtonChange} 
        handleButtonCopy={handleButtonCopy}
        handleButtonDelete={handleButtonDelete}
        showImage={showImage}
        clearFields={clearFields} // Hier wird die Funktion als Prop uebergeben
        newSaveID={newSelectedRowID} // Funktion zum Markieren des neuen Datensatzes in Tabelle uebergeben
        isAnyIconClicked={clickedAnyIcon}
        showDatasheetIcon={false} // Datasheet icon wird in Tabelle nicht angezeigt
        canCreate={can_create_machine_configuration}
        canUpdate={can_update_machine_configuration}
        canDelete={can_delete_machine_configuration}
      />
      <div className='area-under-table'>
        {/* Nur anzeigen, wenn can_update true ist */}
        {can_update_machine_configuration && (
        <div className='area-change'>
          <div className='box-title'>
            <h3>Hier können Sie die Parameter ändern:</h3>
          </div>

          {fields.map(field => {
            const fieldValue = post[field.name];
            // Setze den Wert auf einen leeren String, wenn er kleiner oder gleich 0 ist
            const displayValue = fieldValue < 0 ? '' : fieldValue;

          return (
            <div key={field.name} className="change-input-row"> 
              <label className={field.label.trim() === '' ? 'empty' : ''}>{field.label}
              </label>  

              <div className="input-with-unit">
                {field.type === 'select' ? (
                <>
                  <select 
                    onChange={handleInput} 
                    name={field.name} 
                    value={displayValue}
                    onFocus={(event) => handleFocus(event, setErrors)}
                    onBlur={(event) => handleBlur(event, fields, {}, (name, value, rules) => 
                      validateField(name, value, rules, setErrors))}
                  >
                    <option value=""></option>
                    {field.name === 'machinetype_name' && sortedMachinetypeNameOptions.length > 0 ? (
                      sortedMachinetypeNameOptions.map((option, index) => (              
                        <option key={index} value={option}>
                          {option}
                        </option>
                      ))
                    ) : null}
                  </select>
                    {/* Fehlernachricht für das aktuelle select-Feld anzeigen */}
                    {errors[field.name] && (
                      <span className="error-message">{errors[field.name]}</span>
                    )}
                </>
                
                    ) : field.type === 'checkbox' ? (
                      <div className="change-input-row-checkbox">
                        <input 
                          type="checkbox"
                          name={field.name}
                          checked={post[field.name]}
                          onChange={handleInput}
                        />
                      </div>
                    ) : field.type === 'textarea' ? (
                      <>
                        <textarea className='textarea'
                          name={field.name}
                          value={displayValue}
                          onChange={handleInput}
                        />
                        {field.unit && (      // rendern nur, wenn field.unit einen Wert hat
                          <select // dropdown-Menu wird gerendert, wenn ein unit (Masseinheit) vorhanden ist
                            className="unit-dropdown"
                            name={field.unit} // Verwenden Sie field.unit direkt als name
                            value={post[field.unit]} // Verwenden Sie field.unit direkt, um den Wert aus post zu erhalten
                            onChange={handleInput} // Übergeben Sie Ihre handleInput-Funktion für onChange                 
                          >
                            <option value="" disabled> </option>

                            {field.unit === 'unit_thread_tension_name' && sortedThreadTensionUnitOptions.length > 0 ? (
                              sortedThreadTensionUnitOptions.map((option, index) => (
                                <option key={index} value={option}>
                                  {option}
                                </option>
                              ))
                            ) : field.unit === 'unit_carriage_speed_name' && sortedSpeedUnitOptions.length > 0 ? (
                              sortedSpeedUnitOptions.map((option, index) => (
                                <option key={index} value={option}>
                                  {option}
                                </option>
                              ))
                            ) : field.unit === 'unit_cullet_depth_name' && sortedCulletDepthUnitOptions.length > 0 ? (
                              sortedCulletDepthUnitOptions.map((option, index) => (
                                <option key={index} value={option}>
                                  {option}
                                </option>
                              ))
                            ) : field.unit === 'unit_hauloff_adjustment_name' && sortedHauloffAdjustmentOptions.length > 0 ? (
                              sortedHauloffAdjustmentOptions.map((option, index) => (
                                <option key={index} value={option}>
                                  {option}
                                </option>
                              ))
                            ) : field.unit === 'unit_sinker_adjustment_name' && sortedSinkerAdjustmentUnitOptions.length > 0 ? (
                              sortedSinkerAdjustmentUnitOptions.map((option, index) => (
                                <option key={index} value={option}>
                                  {option}
                                </option>
                              ))
                            ) : null}
                          </select>
                          )}
                      </>
                    ) : (
                    <>
                      <input
                       type={field.type} // Texteingabefelder
                        name={field.name}
                        value={displayValue}
                        onChange={handleInput}
                        readOnly={field.name === 'machinetype_name' || field.name === 'machine_configuration_name'} // diese Felder können nicht geändert werden (nur lesen)
                        
                        onFocus={(event) => handleFocus(event, setErrors)}
                        onBlur={(event) => handleBlur(event, fields, {}, (name, value, rules) => 
                          validateField(name, value, rules, setErrors))}
                      />
                      {errors[field.name] && <span className="error-message">{errors[field.name]}</span>}     

                      {field.unit && (      // rendern nur, wenn field.unit einen Wert hat                    
                        <select // dropdown-Menu wird gerendert, wenn ein unit (Masseinheit) vorhanden ist
                          className="unit-dropdown"
                          name={field.unit}
                          value={post[field.unit]}
                          onChange={handleInput}
                        >

                          <option value="" disabled> </option>
                                              
                          {field.unit === 'unit_thread_tension_name' && sortedThreadTensionUnitOptions.length > 0 ? (
                            sortedThreadTensionUnitOptions.map((option, index) => (
                              <option key={index} value={option}>
                                {option}
                              </option>
                            ))
                          ) : field.unit === 'unit_carriage_speed_name' && sortedSpeedUnitOptions.length > 0 ? (
                            sortedSpeedUnitOptions.map((option, index) => (
                              <option key={index} value={option}>
                                {option}
                              </option>
                            ))
                          ) : field.unit === 'unit_cullet_depth_name' && sortedCulletDepthUnitOptions.length > 0 ? (
                            sortedCulletDepthUnitOptions.map((option, index) => (
                              <option key={index} value={option}>
                                {option}
                              </option>
                            ))
                          ) : field.unit === 'unit_hauloff_adjustment_name' && sortedHauloffAdjustmentOptions.length > 0 ? (
                            sortedHauloffAdjustmentOptions.map((option, index) => (
                              <option key={index} value={option}>
                                {option}
                              </option>
                            ))
                          ) : field.unit === 'unit_sinker_adjustment_name' && sortedSinkerAdjustmentUnitOptions.length > 0 ? (
                            sortedSinkerAdjustmentUnitOptions.map((option, index) => (
                              <option key={index} value={option}>
                                {option}
                              </option>
                            ))
                          )  : null}
                        </select>
                      )}
                    </>
                  )}
              </div>
            </div>
            );
          })}

          <div className='area-change-button'>
            <button onClick={() => clearFields()}>ABBRECHEN</button>
            <button onClick={() => handleSave(post.id_machine_configuration)}>SPEICHERN</button>       
          </div>
        </div> /*Ende area-change*/
      )}  

        <div className='area-image'>
          {/* Anzeigen des Bildes, wenn imageUrl vorhanden ist */}
          {imageUrl && <img src={imageUrl} alt="kein Foto vorhanden" />}
        </div> {/*Ende area-image*/}
      </div> {/*Ende area-under-table*/}  

      {/* für popup NEU */}
      {isNewPopupOpen && (
        <div className="new-popup-overlay">
          <div className="new-popup-content">
            <span onClick={closeNewPopup} className="new-popup-close">
              &times;
            </span>
            <KnittingmachineConfigurationNew
              closeNewPopup={closeNewPopup}
              fields={fields} // Eingabefelder für neuen Datensatz
              sortedMachinetypeNameOptions={sortedMachinetypeNameOptions}
              sortedThreadTensionUnitOptions={sortedThreadTensionUnitOptions}
              sortedSpeedUnitOptions={sortedSpeedUnitOptions}
              sortedCulletDepthUnitOptions={sortedCulletDepthUnitOptions}
              sortedHauloffAdjustmentOptions={sortedHauloffAdjustmentOptions}
              sortedSinkerAdjustmentUnitOptions={sortedSinkerAdjustmentUnitOptions}
              fetchMachineConfiguration={fetchMachineConfiguration}
              fetchMachinetypeOptions={fetchMachinetypeOptions}
              copiedData={copiedData}
              newSaveID={newSaveID}
              formatTimestampNow={formatTimestampNow}
              convertCommaToDotForFloatFields={convertCommaToDotForFloatFields}
              setDefaultForEmptyNumberFields={setDefaultForEmptyNumberFields}
              handleFocus={handleFocus}
              handleBlur={handleBlur}
              validateField={validateField}
              setErrors={setErrors}
              errors={errors}
              setErrorMessage={setErrorMessage}
              setShowErrorModal={setShowErrorModal}
            />
          </div>
        </div>
      )}

      <DeleteConfirmation
        isOpen={isDeletePopupOpen}
        onClose={closeDeletePopup}
        onConfirm={handleConfirmDelete}
      />

      {/* Modal zur Fehlermeldung anzeigen, wenn showErrorModal true ist */}
      {showErrorModal && (
        <IncorrectInputModalModal
          message={errorMessage} // Dynamische Nachricht übergeben
          onClose={() => setShowErrorModal(false)} // Schließt das Modal
        />
      )}

    </MainLayout>
  );
}


export default KnittingmachineConfigurationPage
